import { CommonModule } from '@angular/common';
import { Component, input, model } from '@angular/core';
import { SwiperDirective } from '@malirang/front-share';
import Swiper from 'swiper';
import { SwiperOptions } from 'swiper/types';

@Component({
  selector: 'app-content-images',
  templateUrl: './content-images.component.html',
  imports: [SwiperDirective, CommonModule],
})
export class ContentImagesComponent {
  imageUrls = input.required<string[]>();

  swiperIndex = model(0);
  swiper: Swiper | null = null;
  swiperOptions: SwiperOptions = {
    slidesPerView: 1,
    centeredSlides: true,
    allowTouchMove: true,
  };
}
